import { Mission } from '@/app/hooks/trade/tradeMission';
import { useIsMobile } from '@/utils/CalVW';
import { useState } from 'react';
import { SubMission } from '..';
import DepositList from './DepositList';
import DurationList from './DurationList';
import MDurationList from './MDurationList';
import VolumeList from './VolumeList';

interface DescriptionProps {
  currentSubMission: SubMission;
  detailDepositMission: Mission | null;
  detailVolumeMission: Mission | null; // 거래량 미션 상세조회 (tiers 포함)
  detailPeriodMission: Mission | null; // 기간 미션 상세조회 (tiers 포함)
  depositMission: Mission | null;
  volumeMission: Mission | null; // 거래량 미션 조회 (유저의 보상 정보 포함)
  periodMission: Mission | null; // 기간 미션 조회 (유저의 보상 정보 포함)
  getMissionReward: (missionId: number) => void;
}

const Description = ({
  currentSubMission,
  detailDepositMission,
  detailVolumeMission,
  detailPeriodMission,
  depositMission,
  volumeMission,
  periodMission,
  getMissionReward,
}: DescriptionProps) => {
  const [isSuccessDepositMissions, setIsSuccessDepositMissions] =
    useState(true);

  const isMobile = useIsMobile();

  // ⚠️ API 최적화: FIRST_DEPOSIT_PROMO 미션 완료 여부 체크를 주석처리
  // ONBOARDING 카테고리 요청이 불필요하므로 제거
  // const { data } = useTradeMission(CategoryType.ONBOARDING);

  // useEffect(() => {
  //   const { missions } = data ?? {};

  //   const firstDepositMission = missions?.find(
  //     (m) => getMissionTemplateCode(m.code) === MissionCode.FIRST_DEPOSIT_PROMO
  //   );

  //   // 첫 입금 미션 완료 여부 체크
  //   if (
  //     firstDepositMission?.userProgress?.claimedAt ||
  //     firstDepositMission?.userProgress?.canClaim
  //   ) {
  //     setIsSuccessDepositMissions(true);
  //   } else {
  //     setIsSuccessDepositMissions(false);
  //   }
  // }, [data]);

  const RenderComponent = () => {
    if (currentSubMission === SubMission.DEPOSIT) {
      if (!depositMission || !detailDepositMission) return null;
      return (
        <DepositList
          mission={depositMission}
          detailMission={detailDepositMission}
          isSuccessDepositMissions={isSuccessDepositMissions}
          getMissionReward={getMissionReward}
        />
      );
    } else if (currentSubMission === SubMission.TRADING_VOLUME) {
      if (!volumeMission || !detailVolumeMission) return null;
      return (
        <VolumeList
          mission={volumeMission}
          detailMission={detailVolumeMission}
          isSuccessDepositMissions={isSuccessDepositMissions}
          getMissionReward={getMissionReward}
        />
      );
    } else if (currentSubMission === SubMission.DURATION) {
      if (!periodMission || !detailPeriodMission) return null;
      return isMobile ? (
        <MDurationList
          mission={periodMission}
          detailMission={detailPeriodMission}
          getMissionReward={getMissionReward}
        />
      ) : (
        <DurationList
          mission={periodMission}
          detailMission={detailPeriodMission}
          getMissionReward={getMissionReward}
        />
      );
    }
  };

  return <RenderComponent />;
};

export default Description;
